import {filter, createSelector} from 'helpers';
import {day} from './day';
import {settings} from './settings';
import {recentlyMissed} from './recently-missed';
import {flatten, action} from 'store/common';
import {sort} from 'store/activities/selectors';

const preference = createSelector(
  settings,
  settings => settings.group,
);

export const list = createSelector(
  [ day, recentlyMissed, preference, sort, action ],
  ( day, recentlyMissed, preference, sort, action ) => {

    if (action == 'tracking') {
      recentlyMissed = [];
      day = filter(day, 'numericalTarget');
    } else {

    }

    const { Completed, ...groups } = sort(day, preference);
    return flatten({ ...groups, recentlyMissed, Completed });
  },
  { memoizeOptions: { maxSize: 100 } },
);
